<template>
  <div>
    <Products
      :finance_configuration_category="finance_configuration_category"
      @get_finance_configuration_category="financeConfigurationCategory"
    />
  </div>
</template>

<script>
import Products from "./item-products/products";

import api from "../../../services/api";

export default {
  name: "ItemProducts",

  components: {
    Products,
  },

  data() {
    return {
      errors: [],

      loading: false,

      finance_configuration_category: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      this.financeConfigurationCategory();
    },

    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
